<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
    <div
        class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950"
        [ngClass]="{
            'shadow-lg border border-zinc-950/10 dark:border-white/10': showHeading
          }">
        <form [formGroup]="memberForm" (ngSubmit)="onSave()">
            <div class="flex justify-between">
                <h1 class="heading" *ngIf="showHeading">
                    Edit
                </h1>
                <div *ngIf="member" class="flex gap-2 rounded-lg border-2 border-dashed p-1">
                    <span class="text-xs-light">Payment Status</span>
                    <span [ngClass]="member.squareCustomer ? 'badge-success':'badge-danger'">
                        {{member.squareCustomer ? 'Enabled' : 'Disabled'}}
                    </span>
                </div>
            </div>
            <hr *ngIf="showHeading" class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="grid gap-4 sm:grid-cols-2">
                <div class="space-y-1">
                    <label class="subheading">
                        First Name <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="firstName" type="text" />
                        </div>
                        <div *ngIf="submitted && form.firstName.errors">
                            <p *ngIf="form.firstName.errors.required" class="pt-1 text-red-600 text-xs">
                                First Name is required
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Middle Name
                    </label>
                    <div>
                        <div>
                            <input formControlName="middleName" type="email" />
                        </div>
                        <!-- <div *ngIf="submitted && form.middleName.errors">
                            <p *ngIf="form.middleName.errors.required" class="pt-1 text-red-600 text-xs">
                                Middle Name is required
                            </p>
                        </div> -->

                    </div>
                </div>


                <div class="space-y-1">
                    <label class="subheading">
                        Last Name <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="lastName" type="text" placeholder="" />
                        </div>
                        <div *ngIf="submitted && form.lastName.errors">
                            <p *ngIf="form.lastName.errors.required" class="pt-1 text-red-600 text-xs">
                                Last Name is required
                            </p>
                        </div>
                    </div>
                </div>

                <!-- displayName -->
                  <div class="space-y-1">
                    <label class="subheading">
                        Display Name <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="displayName" type="text" placeholder="" />
                        </div>
                       
                    </div>
                </div>

                <div class="space-y-1">
                    <label class="subheading">
                        Gender <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <select formControlName="gender">
                            <option value="">Select Gender</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                            <option value="other">Other</option>
                        </select>

                        <div *ngIf="submitted && form.gender.errors">
                            <p *ngIf="form.gender.errors.required" class="pt-1 text-red-600 text-xs">
                                Gender is required
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Weight
                        <span class="text-xs-light">(lbs)</span>

                    </label>
                    <div>
                        <div>
                            <input formControlName="weight" type="text" />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Date of Birth <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input type="text" name="time" id="time" formControlName="dateOfBirth" [owlDateTime]="dtdateOfBirth" [readOnly]="true"
                                [owlDateTimeTrigger]="dtdateOfBirth" [min]="getTimeRestrictions().min" [max]="getTimeRestrictions().max" />
                            <owl-date-time [pickerType]="'calendar'" (afterPickerClosed)="onDateChange(form.dateOfBirth)"
                                #dtdateOfBirth></owl-date-time>
                        </div>
                        <div *ngIf="submitted && form.dateOfBirth.errors">
                            <p *ngIf="form.dateOfBirth.errors.required" class="pt-1 text-red-600 text-xs">
                                Date of Birth is required
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Contact Number <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="contactNumber" type="text" />
                        </div>
                        <div *ngIf="submitted && form.contactNumber.errors">
                            <p *ngIf="memberForm.get('contactNumber')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                Contact Number is required
                            </p>
                            <p *ngIf="submitted && (memberForm.get('contactNumber')?.errors?.minlength || memberForm.get('contactNumber')?.errors?.maxlength)" class="pt-1 text-red-600 text-xs">
                                Minimum 10 digits are required and maximum 13 digits are allowed
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Phone Number
                    </label>
                    <div>
                        <div>
                            <input formControlName="phoneNumber" type="text" />
                        </div>
                        <div *ngIf="submitted && form.contactNumber.errors">
                            <p *ngIf="submitted && (memberForm.get('phoneNumber')?.errors?.minlength || memberForm.get('phoneNumber')?.errors?.maxlength)" class="pt-1 text-red-600 text-xs">
                                Minimum 10 digits are required and maximum 13 digits are allowed
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Email <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="email" type="text" />
                        </div>
                        <div *ngIf="submitted && form.email.errors">
                            <p *ngIf="form.email.errors.required" class="pt-1 text-red-600 text-xs">
                                Email is required
                            </p>
                            <div *ngIf="form.email.errors.email" class="error">
                                <p class="mt-2 text-xs text-red-500" id="title-description">
                                    Invalid Email format
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Spoken Languages
                    </label>
                    <div>
                        <div>
                            <input formControlName="languageSpoken" type="text" />
                        </div>
                    </div>
                </div>
                <ng-container formGroupName="address">
                    <div class="space-y-1">
                        <label class="subheading">
                            Address <span class="text-red-600">*</span>
                        </label>
                        <div>
                            <input googlePlace (onSelect)="onSelectAddress($event)" formControlName="name" type="text"
                               (input)="onChangeAddress()"  placeholder="Enter the address" />
                            <div *ngIf="submitted" class="error">
                                <p *ngIf="addressForm.get('name')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                    Address is required
                                </p>
                                <p *ngIf="addressForm?.errors?.invalidAddress"
                                    class="mt-2 text-red-600 text-xs">
                                    Invalid address (select from the dropdown)
                                </p>
                            </div>
                        </div>

                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            City <span class="text-red-600">*</span>
                        </label>
                        <div>
                            <input formControlName="city" type="text" placeholder="" />
                            <div
                                *ngIf="submitted && addressForm.get('city')?.errors">
                                <p *ngIf="addressForm.get('city')?.errors?.required"
                                    class="pt-1 text-red-600 text-xs">
                                    City is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            State <span class="text-red-600">*</span>
                        </label>
                        <div>
                            <input formControlName="state" type="text" placeholder="" />
                            <div
                                *ngIf="submitted && addressForm.get('state')?.errors">
                                <p *ngIf="addressForm.get('state')?.errors?.required"
                                    class="pt-1 text-red-600 text-xs">
                                    State is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            Zip Code <span class="text-red-600">*</span>
                        </label>
                        <div>
                            <div>
                                <input formControlName="zipCode" type="text" />
                            </div>
                            <div *ngIf="submitted && addressForm.get('zipCode')?.errors">
                                <p *ngIf="addressForm.get('zipCode')?.errors?.required"
                                    class="pt-1 text-red-600 text-xs">
                                    Zip Code is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            Apt/Suite/Room
                        </label>
                        <div>
                            <div>
                                <input formControlName="aptSuiteRoom" type="text" />
                            </div>
                        </div>
                    </div>
                </ng-container>
                <div class="space-y-1">
                    <label class="subheading">
                        WMR Number
                    </label>
                    <div>
                        <div>
                            <input formControlName="wmrNumber" type="text" />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Medical Record Number
                    </label>
                    <div>
                        <div>
                            <input formControlName="medicalRecordNumber" type="text" />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Appointment Type
                    </label>
                    <div>
                        <div>
                            <div>
                                <select formControlName="appointmentType">
                                    <option value=""> Select Appointment Type</option>
                                    <option *ngFor="let appointment of appointmentTypes" value="{{appointment.id}}">
                                        {{appointment.title | titlecase}}</option> 
                                </select>
                            </div>
                        </div>
                        <div *ngIf="submitted && form.appointmentType.errors">
                            <p *ngIf="form.appointmentType.errors.required" class="pt-1 text-red-600 text-xs">
                                Appointment Type is required
                            </p>
                        </div>
                    </div>
                </div>
                
                <!-- <div class="space-y-1">
                    <label class="subheading">
                        Allow SMS
                    </label>
                    <div>
                        <div>
                            <select formControlName="allowSMS">
                                <option [value]="true">Yes</option>
                                <option [value]="false">No</option>
                            </select>
                        </div>
                        <div *ngIf="submitted && form.abuse.errors">
                        <p *ngIf="form.abuse.errors.required" class="pt-1 text-red-600 text-xs">
                            Convicted status is required
                        </p>
                    </div>
                    </div>
                </div> -->
                <!-- <div class="space-y-1">
                <label class="subheading">
                    Level of Service
                </label>
                <div>
                    <div>
                        <select formControlName="levelOfService">
                            <option value=""> Select Level of Service</option>
                            <option *ngFor="let los of levelOfServices" value="{{los.id}}">{{los.title}}</option>
                        </select>
                    </div>
                    <div *ngIf="submitted && form.levelOfService.errors">
                        <p *ngIf="form.levelOfService.errors.required" class="pt-1 text-red-600 text-xs">
                            Level of Service is required
                        </p>
                    </div>
                </div>
            </div> -->
                <!-- <div class="space-y-1">
                <label class="subheading">
                    Space Type
                </label>
                <div>
                    <div>
                        <select formControlName="spaceType">
                            <option value=""> Select Space Type</option>
                            <option *ngFor="let spaceType of spacetypes" value="{{spaceType.id}}">{{spaceType.title}}</option>
                        </select>
                    </div>
                    <div *ngIf="submitted && form.spaceType.errors">
                        <p *ngIf="form.spaceType.errors.required" class="pt-1 text-red-600 text-xs">
                            Space Type is required
                        </p>
                    </div>
                </div>
            </div> -->
                <div class="space-y-1">
                    <label for="los" class="subheading">Level of Service <span class="text-red-600">*</span></label>
                    <div class="mt-1">
                        <ng-select id="los" formControlName="levelOfService" [clearable]="false"
                            (change)="onSelectLOS($event)"
                            [ngClass]="(submitted && form.levelOfService.errors?.required) ? 'border-main-danger' : 'border-gray-50'"
                            class="">
                            <ng-option value="">Select Level of Service</ng-option>
                            <ng-option *ngFor="let los of levelOfServiceList" value="{{ los.id }}">{{los.title | uppercase}}</ng-option>
                        </ng-select>
                    </div>
                    <div *ngIf="form.levelOfService.errors && submitted">
                        <div *ngIf="form.levelOfService.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                Level of Service is required
                            </p>
                        </div>
                    </div>
                </div>
                <div *ngIf="spaceTypeList && spaceTypeList.length > 0" class="space-y-1">
                    <label for="spaceType" class="subheading">Space Type <span class="text-red-600">*</span></label>
                    <div class="mt-1">
                        <ng-select id="spaceType" formControlName="spaceType" [clearable]="false"
                            class="">
                            <ng-option value=""> Select Space Type</ng-option>
                            <ng-option *ngFor="let spaceType of spaceTypeList"
                                value="{{ spaceType.id }}">{{spaceType.title | uppercase}}
                            </ng-option>
                        </ng-select>
                    </div>
                    <div *ngIf="form.spaceType.errors && submitted">
                        <div *ngIf="form.spaceType.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                Space Type is required
                            </p>
                        </div>
                    </div>
                </div>
                <!-- funding source -->

                <div class="space-y-1">
                    <label for="fundingSource" class="subheading">Funding Source <span class="text-red-600">*</span></label>
                    <div class="mt-1">
                        <ng-select id="fundingSource" formControlName="fundingsource" [clearable]="false" class="" [readonly]="true">
                            <ng-option value=""> Select Funding Source</ng-option>
                            <ng-option *ngFor="let fundingSource of fundingSourceList" value="{{ fundingSource.id }}">{{fundingSource.title | titlecase}}
                            </ng-option>
                        </ng-select>
                    </div>
                    <div *ngIf="form.fundingsource.errors && submitted">
                        <div *ngIf="form.fundingsource.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                Funding Source is required
                            </p>
                        </div>
                    </div>
                </div>
               
                <ng-container formGroupName="responsibleParty">
                    <div class="space-y-1">
                        <label class="subheading">
                            Responsible Party Name <span class="text-red-600">*</span>
                        </label>
                        <div>
                            <div>
                                <input formControlName="name" type="text" />
                            </div>
                                <div *ngIf="submitted && responsibleParty.get('name')?.errors">
                                    <p *ngIf="responsibleParty.get('name')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                          Responsible Party Name is required
                                     </p>
                                 </div>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            Responsible Party Phone Number <span class="text-red-600">*</span>
                        </label>
                        <div>
                            <div>
                                <input formControlName="phoneNumber" type="text" />
                            </div>
                            <div>
                                <div *ngIf="submitted && responsibleParty.get('phoneNumber')?.errors" class="text-danger">
                                    <p *ngIf="responsibleParty.get('phoneNumber')?.errors?.required" class="pt-1 text-red-600 text-xs">Responsible Party Phone Number is required</p>
                                    <p *ngIf="responsibleParty.get('phoneNumber')?.errors?.minlength || responsibleParty.get('phoneNumber')?.errors?.maxlength" class="pt-1 text-red-600 text-xs">
                                    Minimum 10 digits are required and maximum 13 digits are allowed
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                 <div class="space-y-1">
                    <label class="subheading">Time Zone</label>
                    <div>
                      <select formControlName="timeZone">
                        <option *ngFor="let tz of timezones" [value]="tz">{{ tz }}</option>
                      </select>
                      <div *ngIf="submitted && form.timeZone.errors">
                        <p *ngIf="form.timeZone.errors.required" class="pt-1 text-red-600 text-xs">
                          Time Zone is required
                        </p>
                      </div>
                    </div>
                  </div>

                <!-- <div class="space-y-1"></div> -->
                <div class="space-y-1">
                    <label class="subheading">
                        Private Notes
                    </label>
                    <div>
                        <div>
                            <textarea formControlName="privateNotes" type="text" name=""></textarea>
                        </div>
                    </div>
                </div>

                <div class="col-span-full space-y-1">
                    <label class="subheading">
                        Profile Image 
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <div class="relative overflow-hidden rounded-full inline-flex mt-1">

                                <img [src]="profileImageURL ? profileImageURL : 'assets/images/profileImagePlaceholder.png'"
                                    alt="Profile Image"
                                    class="relative h-32 w-32 rounded-full border border-main-base" />
                                <label for="Profile"
                                    class="absolute inset-0 flex h-full w-full items-center justify-center bg-black bg-opacity-75 text-sm font-medium text-white opacity-0 focus-within:opacity-100 hover:opacity-100">
                                    <span>Change</span>
                                    <input #logoInput type="file" accept="image/*" style="width: 100%;"
                                        (change)="processFile(logoInput)" type="file" id="Profile" name="Profile Image"
                                        class="absolute inset-0 h-full w-full cursor-pointer rounded-md border-main-base opacity-0" />
                                </label>
                            </div>
                            <!-- <div *ngIf="form.profileImageURL.errors && submitted">
                                <div *ngIf="form.profileImageURL.errors.required" class="error">
                                    <p class="mt-2 text-red-600 text-xs">
                                        Profile Image is required
                                    </p>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>

            </section>
            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="flex justify-end gap-4">
                <button type="submit" class="btn btn-secondary">
                    {{memberId ? 'Update' : 'Create'}}
                </button>
            </section>
        </form>
    </div>
</section>